export enum ReservationStatus {
  Open = "Open",
  Confirmed = "Confirmed",
  Canceled = "Canceled",
  Closed = "Closed",
}
